import { action } from 'satcheljs';

export const onAppPaneGroupReady: () => {} = action('onAppPaneGroupReady', (): {} => ({}));
